module.exports = __webpack_public_path__ + "static/media/Dunes2.e8cc841f.jpg";